/*
 * @Author: caiqin.xie
 * @since: 2023-08-24 16:13:13
 * @lastTime: 2023-09-08 09:50:44
 * @LastEditors: caiqin.xie
 * @message: 封装公共方法
 */
interface NObject {
  [key: string]: string | number | undefined | null | void
}
// 获取地址栏参数
export const getUrlData = (link: string = window.location.href): NObject => {
  const url = link
  const obj = {} as NObject  // 此处声明之后可以用方括号的方式设置对象的键值
  if (url.includes('?')) {
    const params = url.split('?')[1].split('&')
    params.map((v) => (obj[v.split('=')[0]] = v.split('=')[1]))
  }
  return obj
}

// 获取文件后缀名
export const getFileExtension = (filename:string) => {
  if (filename) {
    return filename.split(".").pop()
  }
  return ''
}